import axios from "axios";

export const getOpenApiToken = async (forceRefresh = false) => {
  let token = localStorage.getItem("alfamindOpenApiToken");
  if (!token || forceRefresh) {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/method/alfamind_auth.auth.get_token?force_refresh=1`,
      { skipAuthRedirect: true }
    );
    token = response.data.message.token;
    localStorage.setItem("alfamindOpenApiToken", token);
  }
  return token;
};

export const postOpenApi = async (url, body, config = {}) => {
  const send = async (forceRefresh) => {
    const token = await getOpenApiToken(forceRefresh);
    return axios.post(url, body, {
      ...config,
      headers: {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
        Signature: process.env.REACT_APP_SAT_OPENAPI_SIGNATURE,
      },
      skipAuthRedirect: true,
    });
  };
  try {
    return await send(false);
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("alfamindOpenApiToken");
      return send(true);
    }
    throw error;
  }
};
